import * as stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  date: {
    color: palette['bronze-500'],
    fontWeight: typography.fontWeighRegular,
    fontSize: {
      default: '18px',
      '@media (max-width: 767px)': '16px',
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-20'],
    },
    textAlign: 'center',
  },
  titleInfo: {
    color: palette.greyWhite,
    fontWeight: typography.fontWeighDemi,
    lineHeight: {
      default: anatomy['size-40'],
      '@media (max-width: 767px)': anatomy['size-36'],
    },
    fontSize: {
      default: anatomy['size-32'],
      '@media (max-width: 767px)': anatomy['size-28'],
    },
    textAlign: 'center',
  },
  subTitleInfo: {
    color: palette['lighted-50'],
    fontWeight: typography.fontWeighRegular,
    marginTop: '8px',
    fontSize: {
      default: '18px',
      '@media (max-width: 767px)': anatomy['size-16'],
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-20'],
    },
    textAlign: 'center',
  },
});
